import api from './api'
import { format } from 'date-fns'

export const createNfceDownloadJob = async (id, dateOf, dateUntil, idempotencyKey) => {
    const dataDe = format(dateOf, 'yyyy-MM-dd')
    const dataAte = format(dateUntil, 'yyyy-MM-dd')
    return await api.post('/api/nfce/download-jobs', null,
        {
            params: { dataDe, dataAte },
            headers: {
                'X-TenantId': id,
                'Idempotency-Key': idempotencyKey,
            }
        })
}

export const getNfceDownloadJob = async (id, jobId, idempotencyKey) => {
    return await api.get(`/api/nfce/download-jobs/${jobId}`,
        {
            headers: {
                'X-TenantId': id,
                'Idempotency-Key': idempotencyKey,
            }
        })
}

export const getNfces = async (id, dateOf, dateUntil, page) => {
    const dataDe = format(dateOf, 'yyyy-MM-dd')
    const dataAte = format(dateUntil, 'yyyy-MM-dd')
    return await api.get('/api/nfce',
        {
            params: { dataDe, dataAte, page },
            headers: { 'X-TenantId': id }
        })
}
